// The FinPath mark's outer ring, echoed outwards into topographic contours.
// Shared by the landing, About and ContactPage sections so the pattern stays
// one piece of artwork across the marketing pages.
export const MARK_OUTLINE =
	'M103.13 31.86 A17.95 17.95 0 0 1 108.45 49.01 L100.24 85.27 A17.95 17.95 0 0 1 88.06 98.45 L52.55 109.48 A17.95 17.95 0 0 1 35.04 105.52 L7.73 80.28 A17.95 17.95 0 0 1 2.41 63.13 L10.62 26.87 A17.95 17.95 0 0 1 22.80 13.69 L58.31 2.66 A17.95 17.95 0 0 1 75.82 6.62 Z';

const MARK_CX = 55.43;
const MARK_CY = 56.07;

const ContourBackdrop = ({
	className,
	rings = 9,
	from = 1.15,
	step = 0.72,
}) => (
	<svg
		className={className}
		viewBox='-260 -260 520 520'
		aria-hidden='true'
		focusable='false'
	>
		<g
			fill='none'
			stroke='#c9cfe8'
			strokeWidth='1'
			strokeLinejoin='round'
			vectorEffect='non-scaling-stroke'
		>
			{Array.from({ length: rings }).map((_, i) => (
				<path
					key={i}
					d={MARK_OUTLINE}
					// non-scaling-stroke keeps every line hairline-thin as it grows
					transform={`scale(${from + i * step}) translate(${-MARK_CX} ${-MARK_CY})`}
					vectorEffect='non-scaling-stroke'
				/>
			))}
		</g>
	</svg>
);

export default ContourBackdrop;
